import { gql } from '@apollo/client';
import { surfaceUnionIdFragment } from 'graphql/surface-node/fragments/surface-node-fragment';
import { linkSettingsDetails } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-points-to-fragment';

export const surfaceNodesLinkSettingsUpdateSubscription = gql`
  subscription surfaceNodesLinkSettingsUpdate($surface: ID!, $user: ID!) {
    surfaceNodesLinkSettingsUpdate(surface: $surface, user: $user) {
      from {
        ...surfaceNodeUnionId
      }
      to {
        ...surfaceNodeUnionId
      }
      settings {
        ...linkSettingsDetails
      }
    }
  }
  ${surfaceUnionIdFragment}
  ${linkSettingsDetails}
`;
